import { useDispatch } from "react-redux";
import { modalSet, nextModalSet } from "_slices/view";
import AreaContainer from "../AreaContainer";
import styles from './upgradeProperty.module.css';
import globalStyles from '../result.module.css';
import logEvent from "lib/ga/miscEvent";
// import * as ga from "lib/ga";
import Link from "next/link";
import { checkLoggedIn } from "context/context";

const UpgradeProperty = ({ type, id, name, noContacts }) => {
  const isLoggedIn = checkLoggedIn()

  const dispatch = useDispatch();

  let title = "Upgrade this Scheme";
  let body =
    "This scheme is not currently sponsored, and therefore only limited details are being displayed. If you would like to understand the benefits associated with sponsoring this scheme.";
  let buttonText = "Upgrade This Scheme";

  if (type == "property") {
    title = "Upgrade this property listing";
    body =
      "If you are the Agent or Landlord who is currently marketing this property and would like to enhance the details shown on Completely Retail, or if this property is no longer available, please contact us below.";
    buttonText = "Upgrade Now";
  }
  if (noContacts) {
    title = "Sorry, we have no contacts for this listing"
    body = "If you are an Agent or Landlord who is currently marketing this scheme and would like to enhance the details shown on Completely Retail please contact us below"
    buttonText = "Contact Us"
  }

  return (
    <AreaContainer area="agents" style={null} extraClass={null}>
      <div className={styles.UpgradeWrapper}>
        <div className={styles.UpgradeContain}>
          <h2 className={globalStyles.subTitleText}>{title}</h2>
          <p className={`${globalStyles.mediumText} ${globalStyles.largeLineHeight} ${globalStyles.lightColorText}`}>
            {body}
          </p>
          {(type == "property" || noContacts) && <button className={styles.UpgradeButton}
            onClick={() => {
              logEvent({
                category: "Property Upgrade",
                action: "Email modal opened",
                label: `Property: ${name}`,
              });
              if (isLoggedIn) {
                dispatch(
                  modalSet({
                    visible: true,
                    type: "upgradeProperty",
                    view: id.toString(),
                  })
                );
              } else {
                dispatch(
                  modalSet({
                    visible: true,
                    type: "auth",
                    view: "login",
                  })
                );
                dispatch(
                  nextModalSet({
                    visible: true,
                    type: "upgradeProperty",
                    view: id.toString(),
                  })
                );
              }
            }}
          >
            <div className={globalStyles.largeText}>{buttonText}</div>
          </button>}
          {type == "scheme" && !noContacts && <Link prefetch={false} href="/landlord-pricing"><button className={styles.UpgradeButton}>
            <div className={globalStyles.largeText}>{buttonText}</div>
          </button></Link>}
        </div>
      </div>
    </AreaContainer>
  );
};

export default UpgradeProperty;
